import { IconProps } from "../../../types/style";

const Home1SVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;

  return (
    <div style={{ height: size + "px" }}>
      <svg
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g id='home 1'>
          <g id='Group'>
            <path
              id='Vector'
              d='M12 14.9927C10.3432 14.9927 9 16.3358 9 17.9927V23.9927H15V17.9927C15 16.3358 13.6568 14.9927 12 14.9927Z'
              fill={color}
            />
            <g id='Group_2'>
              <path
                id='Vector_2'
                d='M17 17.9926V23.9926H21C22.6568 23.9926 24 22.6495 24 20.9926V11.8716C24.0002 11.3521 23.7983 10.8529 23.437 10.4796L14.939 1.29261C13.4396 -0.329735 10.9089 -0.429344 9.28655 1.07009C9.20949 1.14134 9.13523 1.21555 9.06403 1.29261L0.581016 10.4766C0.208734 10.8515 -0.000140554 11.3584 7.09607e-08 11.8866V20.9926C7.09607e-08 22.6495 1.34316 23.9926 3 23.9926H6.99998V17.9926C7.01869 15.2658 9.22027 13.0391 11.8784 12.9749C14.6255 12.9087 16.9791 15.1733 17 17.9926Z'
                fill={color}
              />
              <path
                id='Vector_3'
                d='M12 14.9927C10.3432 14.9927 9 16.3358 9 17.9927V23.9927H15V17.9927C15 16.3358 13.6568 14.9927 12 14.9927Z'
                fill={color}
              />
            </g>
          </g>
        </g>
        <defs>
          <clipPath id='clip0_54_2020'>
            <rect width='24' height='24' fill='white' />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default Home1SVG;
